import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import api from '../components/setupAxios';
import { Container, Paper, Box, Typography, TextField, Button, Alert} from '@mui/material'; 

function Login({ onLogin }) {
  const [userId, setUserId] = useState(""); // Updated to use userId instead of email
  const [password, setPassword] = useState("");
  const [role, setRole] = useState("student"); // Default role
  const [error, setError] = useState("");

  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
  
    try {
      const response = await api.post("/auth/login", { userId, password });
      console.log("Login successful: ", response.data);
  
      const { token, firstName, role } = response.data;

      localStorage.setItem('token', token);

      window.dispatchEvent(new Event("storage"));

      if (onLogin) {
        onLogin({ username: firstName });
      }

      if (role === 'student') {
        navigate('/');
      } else if (role === 'staff') {
        navigate('/admin-dashboard');
      } else if (role === 'assistant') {
        navigate('/assistant-dashboard');
      } else {
        navigate('/');
      }
  
    } catch (err) {
      if (err.response) {
        setError(err.response.data.error);
      } else {
        setError("Something went wrong.");
      }
    }
  };
  

  return (
    <Container maxWidth="xs" sx={{ mt: 8 }}>
      <Paper elevation={3} sx={{ p: 3 }}>
        <Typography variant="h5" align="center" gutterBottom>
          Login
        </Typography>

        {/* 如果有错误信息，用 MUI Alert 显示 */}
        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}

        <Box component="form" onSubmit={handleSubmit} noValidate>
          <TextField
            label="User ID"
            variant="outlined"
            fullWidth
            margin="normal"
            required
            value={userId}
            onChange={(e) => setUserId(e.target.value)}
          />

          <TextField
            label="Password"
            type="password"
            variant="outlined"
            fullWidth
            margin="normal"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />

          <Button
            type="submit"
            variant="contained"
            color="primary"
            fullWidth
            sx={{ mt: 2 }}
          >
            Sign In
          </Button>
          <Typography variant="caption" color="textSecondary">
            Default password is your User ID
          </Typography>
        </Box>
      </Paper>
    </Container>
  );
}

export default Login;
